var map = {
	"./404.svg": "0VJI",
	"./bug.svg": "dm9c",
	"./chart.svg": "qHis",
	"./clipboard.svg": "I03m",
	"./component.svg": "jpfn",
	"./dashboard.svg": "Iuzh",
	"./documentation.svg": "mL6r",
	"./drag.svg": "6wtt",
	"./easyicon.svg": "sACR",
	"./edit.svg": "04SK",
	"./email.svg": "Jvlx",
	"./example.svg": "MVC2",
	"./excel.svg": "lXC7",
	"./eye.svg": "oxfE",
	"./form.svg": "HbpF",
	"./guide 2.svg": "WtnU",
	"./guide.svg": "HLEY",
	"./icon.svg": "Fbfg",
	"./international.svg": "353E",
	"./language.svg": "uSl1",
	"./link.svg": "kKPj",
	"./list.svg": "95W7",
	"./lock.svg": "EN3V",
	"./message.svg": "yvAI",
	"./money.svg": "IF5j",
	"./nested.svg": "dbH1",
	"./password.svg": "74Gh",
	"./people.svg": "JP5W",
	"./peoples.svg": "JcqQ",
	"./qq.svg": "igmI",
	"./shopping.svg": "R6+o",
	"./size.svg": "1o6k",
	"./star.svg": "rmOC",
	"./tab.svg": "R9fo",
	"./table.svg": "Ai84",
	"./theme.svg": "DYO4",
	"./tree.svg": "MWzf",
	"./user.svg": "EOg8",
	"./wechat.svg": "R0XQ",
	"./zip.svg": "HTd0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 55